export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10343.efbb7690.jpg";